import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Message } from "primereact/message";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { statusActions } from "../../store/status-store/status-slice";
import { uiActions } from "../../store/ui-slice";
import { InputTextarea } from "primereact/inputtextarea";
import { useEffect } from "react";
import { getTokenInfo } from "../../utils/Guard";
import { ColorPicker } from "primereact/colorpicker";

let restartPage = false;

const StatusForms = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const status = props.status;
  const isValid = useSelector((state) => state.status.statusValidation);
  const userInfo = getTokenInfo();
  const notification = useSelector((state) => state.ui.notification);

  useEffect(() => {
    if (
      notification &&
      notification.status === "success" &&
      status.id > 0 &&
      restartPage
    ) {
      dispatch(statusActions.restartState());
      window.location.href = "/status";
    }
  }, [status.id, dispatch, navigate, notification]);
  
  const onChangeHandler = (id, value) => {
    dispatch(statusActions.modifyPropertyValue({ id, value }));
    if (value !== "") {
      dispatch(statusActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(statusActions.setFieldValid({ id, value: false }));
    }
  };
  const getFormErrorMessage = (id) => {
    return !isValid[id].isValid ? (
      <Message severity="warn" text={isValid[id].errorMessage} />
    ) : (
      <small className="p-warn">&nbsp;</small>
    );
  };
  const onSubmitHandler = (event) => {
    event.preventDefault();
    if (status.name === "") {
      dispatch(statusActions.setFieldValid({ id: "name", value: false }));
      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    } else {
      dispatch(props.actionStatus(status, userInfo.Email));
      restartPage = true;
    }
  };

  return (
    <>
      <Card
        style={{
          backgroundColor: "#F9FAFB",
          marginBottom: "0",
          boxShadow: "none",
          height: "auto",
          width: "100%",
        }}
      >
        <form onSubmit={onSubmitHandler}>
          <div className="formgrid grid">
            <div className="field col-12 md:col-12">
              <h2 className="card-header" style={{ color: "" }}>
                Cargo:
                <span style={{ color: "#D34330", marginLeft: "1%" }}>
                  {status && status.name && status.name}
                </span>
              </h2>
            </div>
            <div className="field col-12 md:col-6">
              <label htmlFor="name" style={{ fontSize: "large", color: "" }}>
                Nombre:
              </label>
              <InputText
                id="name"
                value={status.name}
                onChange={(e) => onChangeHandler("name", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
              <div>{getFormErrorMessage("name")}</div>
            </div>

            <div className="field col-12 md:col-8">
              <div className="field col-12 md:col-6">
                <label htmlFor="color" style={{ fontSize: "large", color: "" }}>
                  Color:
                </label>
                <ColorPicker
                  id="color"
                  value={status.color}
                  onChange={(e) =>
                    onChangeHandler("color", "#" + e.value.toUpperCase())
                  }
                  style={{ width: "100%" }}
                />
              </div>

              <label
                htmlFor="description"
                style={{ fontSize: "large", color: "" }}
              >
                Descripción:
              </label>
              <InputTextarea
                id="description"
                rows={4}
                cols={10}
                value={status.description}
                onChange={(e) => onChangeHandler("description", e.target.value)}
                placeholder=""
                style={{ width: "100%" }}
              />
            </div>
          </div>
          <div className="formgrid grid">
            <Button
              rounded
              text
              raised
              style={{ backgroundColor: "#fff" }}
              label="Regresar"
              icon="pi pi-arrow-left"
              className="p-button-danger"
              onClick={() => {
                navigate("/status");
              }}
            />

            <Button
              rounded
              text
              raised
              style={{ backgroundColor: "#fff", marginLeft: "1%" }}
              label="Guardar"
              className="p-button-success"
              icon={
                notification && notification.status === "pending"
                  ? "pi pi-spin pi-spinner"
                  : "pi pi-save"
              }
              disabled={notification && notification.status === "pending"}
            />
          </div>
        </form>
      </Card>
    </>
  );
};
export default StatusForms;
